"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.accountPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccountAvatar = _interopRequireDefault(require("./AccountAvatar"));

var _AccountSecondaryLink = _interopRequireDefault(require("./AccountSecondaryLink/AccountSecondaryLink"));

var _AccountNav = require("./AccountNav.style");

var Account = function Account(_ref) {
  var account = _ref.account,
      variant = _ref.variant,
      isLargeNav = _ref.isLargeNav,
      variation = _ref.variation,
      toggleNav = _ref.toggleNav,
      rest = _objectWithoutProperties(_ref, ["account", "variant", "isLargeNav", "variation", "toggleNav"]);

  var avatar = account.avatar,
      avatarNotifications = account.avatarNotifications,
      accountPrimaryLinks = account.accountPrimaryLinks,
      avatarPrimaryLink = account.avatarPrimaryLink,
      avatarSecondaryLink = account.avatarSecondaryLink,
      avatarMenuLinks = account.avatarMenuLinks;
  return /*#__PURE__*/_react.default.createElement(_AccountNav.AccountNav, Object.assign({
    variant: variant,
    accountPrimaryLinks: accountPrimaryLinks,
    variation: variation
  }, rest), accountPrimaryLinks && accountPrimaryLinks.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_AccountNav.AccountLink, Object.assign({
      key: link.label,
      to: link.url,
      variant: variant,
      enhanced: true,
      onClick: function onClick() {
        toggleNav();
      }
    }, link), link.label);
  }), avatar && /*#__PURE__*/_react.default.createElement(_AccountAvatar.default, {
    avatar: avatar,
    variant: variant,
    avatarMenuLinks: avatarMenuLinks,
    avatarPrimaryLink: avatarPrimaryLink,
    avatarNotifications: avatarNotifications,
    isLargeNav: isLargeNav,
    variation: variation,
    toggleNav: toggleNav
  }), avatarSecondaryLink && /*#__PURE__*/_react.default.createElement(_AccountSecondaryLink.default, {
    avatarSecondaryLink: avatarSecondaryLink,
    variant: variant,
    toggleNav: toggleNav
  }));
};

var accountPropTypes = {
  avatar: _propTypes.default.shape({
    description: _propTypes.default.string,
    label: _propTypes.default.string
  }),
  accountPrimaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  avatarPrimaryLink: _propTypes.default.string,
  avatarNotifications: _propTypes.default.shape({
    url: _propTypes.default.string,
    counter: _propTypes.default.number
  }),
  avatarSecondaryLink: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    icon: _propTypes.default.string
  }),
  avatarMenuLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    counter: _propTypes.default.number
  }))
};
exports.accountPropTypes = accountPropTypes;
Account.propTypes = {
  account: _propTypes.default.shape(accountPropTypes),
  isLargeNav: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['slider', 'mega', 'primary']),
  variation: _propTypes.default.oneOf(['mega', 'primary']),
  toggleNav: _propTypes.default.func
};
Account.defaultProps = {
  account: null,
  isLargeNav: false,
  variant: 'primary',
  variation: 'mega',
  toggleNav: null
};
var _default = Account;
exports.default = _default;